import { Collection } from 'modules/core/lib/mobx-rest'

import TeamShiftLocationAnalytics from 'modules/teams/store/models/TeamShiftLocationAnalytics'

class TeamsShiftLocation extends Collection<TeamShiftLocationAnalytics> {
  get cacheKey(): string {
    return 'teamsShiftLocation'
  }
  model() {
    return TeamShiftLocationAnalytics
  }
}

const singleton: TeamsShiftLocation = new TeamsShiftLocation()

export { TeamsShiftLocation }

export default singleton
